import { render } from "./DSVGOGenerator.vue?vue&type=template&id=7605f610&scoped=true"
import script from "./DSVGOGenerator.vue?vue&type=script&lang=js"
export * from "./DSVGOGenerator.vue?vue&type=script&lang=js"

import "./DSVGOGenerator.vue?vue&type=style&index=0&id=7605f610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7605f610"]])

export default __exports__